<div class="object-copy">
  <app-section-view-copy
    [sectionsContainer]="sectionsContainer()"
    [sourceArtifactId]="sourceArtifactId()"
  />
</div>
